import { useContext } from 'react'

import { UserContext } from '../context'


export const useUser = () => {
    const { user, isSignedIn, isInitialized, error } = useContext(UserContext)
    return { user, isInitialized, isSignedIn, error }
}
